import React from 'react';
import {
  Spacer, Text, Loader, Logo,
} from '@myinterview/component-library';
import { useTranslation } from 'react-i18next';

interface IJobHeader {
  logoUrl: string;
  jobTitle: string;
  companyName: string;
  isLoading: boolean;
}

export const JobHeader = ({
  logoUrl, jobTitle, companyName, isLoading,
}: IJobHeader) => {
  const { t } = useTranslation();
  return (
    <div className="job-header">
      <Logo className="job-header__logo" isLoading={isLoading} url={logoUrl} />
      <Spacer x={1} />
      <div className="job-header__title">
        {isLoading ? <Loader />
          : (
            <>
              <Text className="job-header__job-title" color="neutral-90" size="M-Regular">{jobTitle}</Text>
              {companyName && (
              <>
                <Spacer y={0.2} />
                <Text
                  className="job-header__company"
                  color="neutral-70"
                  size="S-Regular"
                >
                  {`${t('at')} ${companyName}`}
                </Text>
              </>
              )}
            </>
          )}
      </div>
    </div>
  );
};
